"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("preact/jsx-runtime");
var compat_1 = require("preact/compat");
var SvgTooltipArrow = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 48, height: 12, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M24 0c2.817 0 2.984 12 12 12H12c9.016 0 9.183-12 12-12Z", fill: "#2962FF" }) }))); };
var Memo = (0, compat_1.memo)(SvgTooltipArrow);
exports.default = Memo;
